export const copied = window._trans?.Copied ?? "Copied";

export async function handleClickCopy(value: string | number) {
  try {
    await navigator.clipboard.writeText(value.toString());
    const copied_confirmation = document.querySelector(".copied_confirmation") as HTMLElement;
    setTimeout(() => {
      copied_confirmation?.click();
    }, 2000);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.log(e);
  }
}
